var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxtbiz-import-proc",
    {
      attrs: {
        "template-url": _vm.templateUrl,
        "app-code": _vm.udp,
        "upload-config": _vm.uploadConfig,
        "on-error": _vm.onError,
      },
      on: { uploaded: _vm.uploaded },
    },
    [
      _vm.importResult && _vm.importResult.isSuccess
        ? _c(
            "div",
            { attrs: { slot: "success" }, slot: "success" },
            [
              _c(
                "yxt-row",
                {
                  staticClass: "color-gray-10 yxt-upload-item-title",
                  attrs: { type: "flex", align: "middle" },
                },
                [
                  _c("span", { staticClass: "yxt-color-success" }, [
                    _vm._v(_vm._s(_vm.importResult.successCount)),
                  ]),
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "pc_biz_udp_import_tip_successcount" /* 条导入成功 */
                        )
                      ) +
                      "\n      "
                  ),
                  _vm.importResult.failedCount
                    ? [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("pc_biz_udp_tip_comma" /* ， */))
                        ),
                        _c("span", { staticClass: "yxt-color-danger" }, [
                          _vm._v(_vm._s(_vm.importResult.failedCount)),
                        ]),
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t(
                                "pc_biz_udp_import_tip_failedcount" /* 条导入失败 */
                              )
                            ) +
                            "\n      "
                        ),
                      ]
                    : _vm._e(),
                  _vm.importResult.repeatCount
                    ? [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("pc_biz_udp_tip_comma" /* ， */))
                        ),
                        _c("span", { staticClass: "yxt-color-danger" }, [
                          _vm._v(_vm._s(_vm.importResult.repeatCount)),
                        ]),
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t(
                                "pc_biz_udp_import_tip_repeatcount" /* 条重复数据 */
                              )
                            ) +
                            "\n      "
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm.importResult.successCount
                ? _c(
                    "yxt-row",
                    {
                      staticClass: "standard-size-12 lh20 mt4",
                      attrs: { type: "flex", align: "middle" },
                    },
                    [
                      _c(
                        "yxt-link",
                        { attrs: { underline: false, type: "success" } },
                        [_c("i", { staticClass: "yxt-icon-success" })]
                      ),
                      _c("span", { staticClass: "color-gray-8 ml3" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "pc_biz_import_tip_importsuccess" /* 导入成功 */
                            )
                          )
                        ),
                      ]),
                      _vm.importResult.filePath
                        ? _c(
                            "yxt-link",
                            {
                              staticClass: "standard-size-12 ml8",
                              attrs: { type: "primary", underline: false },
                              on: {
                                click: function ($event) {
                                  return _vm.downloadError(
                                    _vm.importResult.filePath
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    _vm.$t(
                                      "pc_biz_udp_import_btn_downloadfaileddata" /* 下载失败数据 */
                                    )
                                  ) +
                                  "\n      "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _c(
                    "yxt-row",
                    {
                      staticClass: "standard-size-12 lh20 mt4",
                      attrs: { type: "flex", align: "middle" },
                    },
                    [
                      _c(
                        "yxt-link",
                        { attrs: { underline: false, type: "danger" } },
                        [_c("i", { staticClass: "yxt-icon-error" })]
                      ),
                      _c("span", { staticClass: "color-gray-8 ml3" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "pc_biz_import_tip_importfailed" /* 导入失败 */
                            )
                          )
                        ),
                      ]),
                      _vm.importResult.filePath
                        ? _c(
                            "yxt-link",
                            {
                              staticClass: "standard-size-12 ml8",
                              attrs: { type: "primary", underline: false },
                              on: {
                                click: function ($event) {
                                  return _vm.downloadError(
                                    _vm.importResult.filePath
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    _vm.$t(
                                      "pc_biz_udp_import_btn_downloadfaileddata" /* 下载失败数据 */
                                    )
                                  ) +
                                  "\n      "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }